/**
 * Mapper usado apenas na página de Planos / Serviços Template (modal novo preço).
 * Faz o parse de títulos do banco para exibição agrupada (ex.: "Cível Presencial" e "Cível Virtual" → "Audiência Cível"),
 * com match normalizado (sem acentos) para não depender da grafia exata do banco.
 * Não altera o comportamento do servicoMapper.ts usado em demandas, proposta e histórico.
 */

import { MAPEAMENTO_TITULO_SERVICO } from './servicoMapper';

function normalizarParaComparacao(s: string): string {
    return s
        .toLowerCase()
        .trim()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");
}

/** Para Audiência: exibe área do direito sem "Audiência" (Civil, Penal, Trabalhista, Outros). Mesma lógica do modal. */
export function labelAreaDireitoAudiencia(displayCompleto: string | null | undefined): string {
  const d = (displayCompleto ?? "").trim().toLowerCase();
  if (!d) return "";
  if (d.includes("cível") || d.includes("civil")) return "Civil";
  if (d.includes("penal")) return "Penal";
  if (d.includes("trabalhista")) return "Trabalhista";
  if (d.includes("outras") || d.includes("outros")) return "Outros";
  return (displayCompleto ?? "").trim();
}

/** Retorna o nome de exibição para planos/serviços (ex.: "Audiência Cível"). Match exato ou sem acentos. */
export function tituloServicoParaExibicaoPlanos(tituloBanco: string | undefined): string {
    if (!tituloBanco?.trim()) return "";
    const t = tituloBanco.trim();
    if (MAPEAMENTO_TITULO_SERVICO[t]) return MAPEAMENTO_TITULO_SERVICO[t];
    const n = normalizarParaComparacao(t);
    for (const [key, value] of Object.entries(MAPEAMENTO_TITULO_SERVICO)) {
        if (normalizarParaComparacao(key) === n) return value;
    }
    return t;
}

/** Nomenclatura: Serviço - Área do Direito (Tipo de Audiência). Usado na listagem de planos e no histórico. */
export function formatServicoColuna(
  categoria: string | null | undefined,
  subtipo: string | null | undefined,
  tipoAudiencia: string | null | undefined
): string {
  const s = tituloServicoParaExibicaoPlanos(categoria ?? undefined);
  const a = labelAreaDireitoAudiencia(subtipo ?? undefined) || tituloServicoParaExibicaoPlanos(subtipo ?? undefined);
  const base = [s, a].filter((p) => p != null && String(p).trim() !== "");
  const tipo = tipoAudiencia != null && String(tipoAudiencia).trim() !== "" ? String(tipoAudiencia).trim() : null;
  if (base.length === 0) return "-";
  const principal = base.join(" - ");
  return tipo ? `${principal} (${tipo})` : principal;
}
